import { Icon, IconSize, IconDisplay } from "@components/Icon";
import { Link } from "@components/Link";

import { spacing } from "@every.org/common/src/display/spacing";
import {
  ClientRouteName,
  getRoutePath,
  URLFormat,
} from "@every.org/common/src/helpers/clientRoutes";

import { DonateV3GridCard } from "src/pages/DonateV3/styles";
import { horizontalStackCss } from "src/theme/spacing";
import { textSizeCss } from "src/theme/text";

export const GiftCardLink = () => {
  return (
    <DonateV3GridCard
      css={[
        textSizeCss.xs,
        horizontalStackCss.s,
        { padding: spacing.m, alignItems: "center" },
      ]}
    >
      <p>
        Give the gift of giving with an Every.org{" "}
        <Link
          data-tname="donateV3GiftCardLink"
          to={getRoutePath({
            name: ClientRouteName.GIFT_CARD_PURCHASE,
            format: URLFormat.RELATIVE,
          })}
        >
          charity gift card
        </Link>
      </p>
      <Icon
        css={{ flexShrink: 0 }}
        iconImport={() => import("@components/Icon/icons/GiftStarsIcon")}
        size={IconSize.X_LARGE}
        display={IconDisplay.ACCENT}
      />
    </DonateV3GridCard>
  );
};
